import { useMemo, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getLoadingBridge } from 'context/GlobalLoadingContext';

const BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:9000';

export default function useHttp(headers) {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  const token = localStorage.getItem('authToken');

  const instance = useMemo(() => {
    const inst = axios.create({
      baseURL: `${BASE_URL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers,
      },
    });

    inst.interceptors.request.use((config) => {
      if (config.showLoader !== false) {
        getLoadingBridge().show();
        config._showedLoader = true;
      }
      return config;
    });

    inst.interceptors.response.use(
      (response) => {
        if (response.config._showedLoader) {
          getLoadingBridge().hide();
        }
        return response;
      },
      (error) => {
        if (error.config?._showedLoader) {
          getLoadingBridge().hide();
        }
        if (error.response?.status === 401 || (error?.response?.status === 404 && error?.response?.data?.message === 'Authentication token missing')) {
          localStorage.clear();
          navigateRef.current('/login');
        }
        return Promise.reject(error);
      }
    );

    return inst;
  }, [token, headers]);

  return instance;
}
